import {
    ACTIONS,
    PhlebognadminTypes
} from ".";

type InitialState = {
    loading: boolean;
    userDetails: Array<any>;
    cities: Array<any>;
    pin_code: Array<any>;
    data: any;
    users: any;
    user_panel: object;
    agentBYUserGroup: object;
    projectSamplesdata: Array<any>;
    projects: Array<any>;
    applications: Array<any>;
    projectsFilterData: Array<any>;
    sampleAllData: Array<any>;
    sapmleList: Array<any>;
    mediaUpload: Array<any>;
    fetchsamplepdata: Array<any>;
    bookingoverview: Array<any>;
    fetchRunPlan: Array<any>;
    FetchConfigData: Array<any>;
    fetchRunSequencing: Array<any>;
    FetchBioInformaticsData: Array<any>;
    fetchFinalReportData: Array<any>;
    postDataFullFill: Array<any>;

};

const initialState: InitialState = {
    loading: false,
    userDetails: [],
    cities: [],
    pin_code: [],
    data: {},
    users: {},
    user_panel: [],
    agentBYUserGroup: {},
    projectSamplesdata: [],
    projects: [],
    applications: [],
    projectsFilterData: [],
    sampleAllData: [],
    sapmleList: [],
    mediaUpload: [],
    fetchsamplepdata: [],
    bookingoverview: [],
    fetchRunPlan: [],
    FetchConfigData: [],
    fetchRunSequencing: [],
    FetchBioInformaticsData: [],
    fetchFinalReportData: [],
    postDataFullFill: [],
};

const GenomicsLabReducer = (
    state = initialState,
    action: PhlebognadminTypes
) => {
    switch (action.type) {

        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.GET_BOOKING_OVERVIEW:
            return {
                ...state,
                bookingoverview: action.payload,
                loading: false,
            };
        case ACTIONS.FETCH_FINAL_REPORT:
            return {
                ...state,
                fetchFinalReportData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BIO_INFORMATICS:
            return {
                ...state,
                FetchBioInformaticsData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SEQUENCING:
            return {
                ...state,
                fetchRunSequencing: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RUN_PLAN:
            return {
                ...state,
                fetchRunPlan: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SAMPLE_PROJECT_DATA:
            return {
                ...state,
                fetchsamplepdata: action.payload,
                loading: false,
            };
        case ACTIONS.UPLOAD_MEDIA_FILES:
            return {
                ...state,
                mediaUpload: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PROJECTS_SAMPLE_LIST:
            return {
                ...state,
                sapmleList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_APPLICATIONS:
            return {
                ...state,
                applications: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA:
            return {
                ...state,
                sampleAllData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PROJECTS_FILTER:
            return {
                ...state,
                projectFilterData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PROJECTS:
            return {
                ...state,
                projects: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PROJECTS_SAMPLE:
            return {
                ...state,
                projectSamplesdata: action.payload,
                loading: false,
            };
        case ACTIONS.GET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CITIES:
            return {
                ...state,
                cities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PIN_CODE:
            return {
                ...state,
                pin_code: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DISPLAY_CITIES:
            return {
                ...state,
                displayCities: action.payload,
                loading: false,
            };
        case ACTIONS.UPLOAD_FILE:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AREA:
            return {
                ...state,
                areaList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AGENTS_BY_USERGROUP:
            return {
                ...state,
                agentBYUserGroup: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CONFIG_DATA:
            return {
                ...state,
                FetchConfigData: action.payload,
                loading: false,
            };
        case ACTIONS.UPDATE_DATA_FULLFILL:
            return {
                ...state,
                postDataFullFill: action.payload,
                loading: false,
            };

        case ACTIONS.RESET_PROJECT:
            return {
                ...state,
                projects: {},
                loading: false,
            };

        default:
            return state;
    }
};

export default GenomicsLabReducer;
